import cn from 'classnames';
import React, { FC, ReactNode, memo } from 'react';

import Typography from '@mui/material/Typography';

import useStyles from './styles.module';

interface Props {
  title: string;
  value: string | ReactNode;
  className?: string;
}

const Row: FC<Props> = ({ title, value, className }) => {
  const { classes } = useStyles();

  return (
    <div className={cn(classes.row, className)}>
      <Typography variant="subtitle1" color={(theme) => theme.primary.p3}>
        {title}
      </Typography>
      <Typography variant="body1">{value}</Typography>
    </div>
  );
};

export default memo(Row);
